// reducer
import { default as reducer } from "./reducer";

export { tokenizeQuery as tokenizeMultiSearchQuery, submitSearch as submitMultiSearch, resetSearch as resetMultiSearch } from "./actions";

export { getMultiSearchText, getMultiSearchTokenizedQuery, getMultiSearchResults, getMultiSearchIsDone } from "./selectors";
export default reducer;
